<p-toast position="top-right"></p-toast>
<div class="login-body">
    <div class="card login-panel p-fluid" style=" border-radius: 2em ;
    margin-top: 11em;
    ">
        <form #loginForm="ngForm">
            <div class="p-g">
                <div class="p-g-12">
                    <img src="assets/layout/images/gym.png">
                </div>
                <div class="p-g-12">
                    <span class="md-inputfield">
                        <input type="text" name="email" id="loginUsername" [(ngModel)]="user.email" #email="ngModel"
                            autocomplete="off" pInputText>
                        <label class="loginLabels">{{setLabel("usernameLabel")}}</label>
                    </span>
                </div>
                <div class="p-g-12">
                    <span class="md-inputfield">
                        <input type="{{passwordType}}" name="password" [(ngModel)]="user.password" #password="ngModel"
                            autocomplete="off" pInputText>
                        <label class="loginLabels">{{setLabel("passwordLabel")}}</label>
                        <span (click)="togglePasswordType()"><i style="position: relative;top: -26px;"
                                class="p-icon-remove-red-eye showHidePassword"></i></span>
                    </span>
                </div>

                <!-- <div *ngIf="isCaptchaShow" style="margin-left: 40px;">
                    <div class="card-body">
                        <div #recaptcha></div>
                    </div>
                </div> -->

                <div class="p-g-12">
                    <!-- <button *ngIf="isCaptchaShow" pButton class="p-button-with-icon-tecfolk-fix" type="button"
                        label="Sign In" (click)="verifyReCaptcha()" style="width: 100%; border-radius: 5px;"
                        icon="p-icon-person" [disabled]="!loginForm.valid || isDisableSignin">
                        <div *ngIf="loading"><p-progressSpinner [style]="{width: '32px', height: '36px'}"
                                styleClass="custom-spinner" strokeWidth="8" fill="#EEEEEE"
                                animationDuration=".5s"></p-progressSpinner></div>
                    </button> -->
                    <button [disabled]="loading" pButton class="p-button-with-icon-tecfolk-fix" type="button"
                    [label]='setLabel("signInLabel")' (click)="login()" style="width: 100%; border-radius: 5px;" icon="p-icon-person"
                        [disabled]="!loginForm.valid">
                        <div *ngIf="loading"><p-progressSpinner [style]="{width: '32px', height: '36px'}"
                                styleClass="custom-spinner" strokeWidth="8" fill="#EEEEEE"
                                animationDuration=".5s"></p-progressSpinner></div>
                    </button>
                </div>
                <div class="p-g-12" style="margin-top: 10px; display: flex; align-items: center; justify-content: center;">
                    <a href="faq.html" target="_blank" style="color: #2F4050; text-decoration: none; font-weight: bold;
                        font-size: 16px; display: flex; align-items: center; transition: color 0.3s, transform 0.3s;">
                        {{setLabel("frequentlyAskedQuestionsLabel")}}
                        <svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" style="margin-left: 5px;">
                            <circle cx="12" cy="12" r="11" fill="#2F4050;" />
                            <text x="50%" y="50%" text-anchor="middle" dy=".3em" fill="#ffffff">?</text>
                        </svg>
                    </a>
                </div>

                <!-- <div class="p-g-12">
                    <div class="card bg-danger" style="max-width: 18rem;background-color: cornsilk; color: maroon;">
                        <div class="card-body">
                            <div *ngIf="error" id="card-text" [innerHtml]="errorMessage"></div>
                        </div>
                    </div>
                </div> -->
            </div>
        </form>
    </div>
</div>